import DataTableContainer from '../../../component/data-table-container/data-table-container';
import React from 'react';
import { CelType, Table } from '../../../component/data-table/data-table';
import generateRowHeader from '../../../component/data-table-container/utils/generate-row-header';

function createTableData(data: string[][]): Table {
  const newTable: Table = {
    rowHeader: generateRowHeader([
      'מס״ד',
      'שם',
      'ת.ז',
      'מטלה 1',
      'מטלה 2',
      'מטלה 3',
      'מטלה 4',
      'מטלה 5',
      'מבחן 1',
      'מבחן 2',
      'מבחן 3',
    ]),

    rows: data.map((row, index) => ({
      cells: row.map((content) => ({
        content: content,
        type: index === 3 ? CelType.GREEN_BG : CelType.REGULAR,
      })),
    })),
  };
  return newTable;
}

const studentsGradesData = [
  [
    '1',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '2',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '3',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '4',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '5',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '6',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '7',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '8',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
  [
    '9',
    'דויד יצחקי',
    '323788343',
    '89',
    '99',
    '97',
    '77',
    '99',
    '97',
    '77',
    '99',
  ],
];

const GradesCoursePage = () => {
  return (
    <div>
      <div style={{ color: '#041E49', fontSize: '20px', fontWeight: 'bold' }}>
        מטלות וציונים
      </div>

      <DataTableContainer
        title={'מטלות וציונים'}
        isLoading={false}
        lazyLoading={{ columnNumber: 4, rowsNumber: 10 }}
        table={createTableData(studentsGradesData)}
      />
    </div>
  );
};

export default GradesCoursePage;
